module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/suset-2-31ff75c0060aec172436c63f807a3de8.svg";